module.exports = __webpack_public_path__ + "static/crisis4-cad3b7cf103e18678cf51410437f13ac.jpg";